<template>
    <router-link to="/" class="logo w-spc3 inline-block">
        <img class="w-full" :src="require('@/assets/images/logo.png')" alt="Logo">
    </router-link>
</template>

<script>
    export default {
        name: "Logo",
        data() {
            return {

            }
        }
    }
</script>

<style scoped>

</style>